export default [
  {
    path: "/kebun-sumber-benih/",
    component: () =>
      import("@/pages/kebun-sumber-benih/kebun-sumber-benih-list.vue"),
    meta: { title: "Daftar Kebun Sumber Benih" },
  },
  {
    path: "/kebun-sumber-benih/create",
    component: () =>
      import("@/pages/kebun-sumber-benih/kebun-sumber-benih-form.vue"),
    meta: { title: "Tambah Kebun Sumber Benih" },
  },
  {
    path: "/kebun-sumber-benih/detail/:id",
    component: () =>
      import("@/pages/kebun-sumber-benih/kebun-sumber-benih-detail.vue"),
    meta: { title: "Detail Kebun Sumber Benih" },
  },
  {
    path: "/kebun-sumber-benih/update/:id",
    component: () =>
      import("@/pages/kebun-sumber-benih/kebun-sumber-benih-update.vue"),
    meta: { title: "Update Kebun Sumber Benih" },
  },
  {
    path: "/kebun-sumber-benih/import",
    component: () =>
      import("@/pages/kebun-sumber-benih/kebun-sumber-benih-import.vue"),
    meta: { title: "Import Kebun Sumber Benih" },
  },
];
